<template>
  <kst-section items-mode>
    <InvoiceItemSearch
      ref="mdlInvoiceItemSearch"
      :items="invoiceItemsSearch" 
      @submit="handleInvoiceItem_Submit"
    />

    <template #top-right>
      <kst-button action-mode
        class="is-primary"
        tag="button"
        :label="Info.Button.InvoiceItem.Label"
        :moduleType="Model.ModuleType.New"
        @click="handleAdd_InvoiceItem"
      />
    </template>

    <template #bottom>
      <template v-if="userItems.length > 0" >
        <kst-button action-mode
          class="is-primary"
          tag="button"
          :label="Info.Button.InvoiceItem.Label"
          :moduleType="Model.ModuleType.New"
          @click="handleAdd_InvoiceItem"
        />
      </template>
    </template>

    <List :userData="userData" :userItems="userItems"/>
  </kst-section>
</template>

<script>
import Info from "../RinvInfo.js";
import Model from "../RinvModel.js";

import InvoiceItemSearch from "../../Invoice/ItemSearch/InvoiceItemSearch.vue";
import List from "./RinvN_Items_List.vue";

export default {
  components: {
    InvoiceItemSearch,
    List
  },
  props: {
    invoiceItems: Array,
    userData: Object,
    userItems: Array
  },
  data: () => ({
    Info: Info,
    Model: Model,
    invoiceItemsSearch: []
  }),
  methods: {
    handleInvoiceItem_Submit(row) {
      let item = Model.createItem();
      Model.New.setItemByInvoiceItem(item, row);
      Model.updateItem(item);
      this.userItems.push(item);

      Model.updateDetails(this.userData, this.userItems);
    },
    handleAdd_InvoiceItem() {
      this.invoiceItemsSearch = Model.getInvoiceItems_ForSelection(
        this.userItems, this.invoiceItems
      );
      this.$refs.mdlInvoiceItemSearch.show();
    }
  }
}
</script>